<app-template-text [counter]="counter" [disabled]="disabled" [characters]="characters" [value]="value" [maxlength]="maxlength" [control]="control" [label]="label" />
